import { styled } from '@mui/material/styles';

import type { TStatusPillVariant } from './types';

export const StyledStatusPill = styled('div')<{ variant: TStatusPillVariant }>(
	({ theme, variant }) => {
		const variants = {
			success: {
				backgroundColor: theme.palette.success.main,
				color: theme.palette.primary.main,
			},
			info: {
				backgroundColor: theme?.palette?.solutions?.[100],
				color: theme.palette.solutions?.[800],
			},
			error: {
				backgroundColor: theme.palette.error.main,
				color: theme.palette.error.contrastText,
			},
			warning: {
				backgroundColor: theme.palette.warning.main,
				color: theme.palette.warning.contrastText,
			},
		};

		return {
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: '4px 10px',
			borderRadius: '13px',
			...variants[variant],
		};
	}
);
